module.exports = __webpack_public_path__ + "static/dufner-plastica-024cb422b1ed36f6dc0c4f6fd0240b3b.jpg";